import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, takeUntil } from 'rxjs/operators';

// CONFIGS

// INTERFACES

import {
  PricingScheduleInterface,
  PricingLevelInterface,
  PricingTierInterface,
  PricingOverrideInterface,
} from './../../pricing/interfaces/pricing.interface';

// PIPES

// SERVICE

@Component({
  selector: 'cnc-rfq-pricing-table',
  templateUrl: './rfq-pricing-table.component.html',
  styleUrls: ['./rfq-pricing-table.component.scss'],
  // No providers needed for standalone pipe
})
export class RfqPricingTableComponent implements OnInit, OnDestroy {
  @Input()
  pricingSchedule :PricingScheduleInterface;

  @Input()
  rfq :any;

  @Input()
  pricingLevels :PricingLevelInterface;

  @Input()
  pricingOverrides :PricingOverrideInterface[];

  @Output()
  tierOverride = new EventEmitter<{
    priceOverride ?:PricingOverrideInterface;
    price :number;
    rfqId :number;
    priceScheduleTierId :number;
    priceLevelId :number;
  }>();

  rowOverrides :boolean[] = [];
  overrideTiers :PricingTierInterface[] = [];
  amountInput$ = new Subject<{
    price :number;
    rfqId :number;
    priceScheduleTierId :number;
    priceLevelId :number;
  }>();

  private onDestroy$ = new Subject();

  constructor() {}

  ngOnInit() :void {
    this.onInputAmountInputUpdated().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onChangeAmount(
    event :Event,
    tier :PricingTierInterface,
    pricingLevel :PricingLevelInterface,
  ) :void {
    const amount = Number(event.target['value']);

    this.amountInput$.next({
      price: amount,
      rfqId: this.rfq.id,
      priceScheduleTierId: tier.id,
      priceLevelId: pricingLevel.id,
    });
  }

  setOverrideRow(key :number, status :boolean) :void {
    this.rowOverrides = [];
    this.rowOverrides[key] = status;
  }

  saveOverride() :void {
    this.rowOverrides = [];
  }

  cancel() :void {
    this.rowOverrides = [];
  }

  private onInputAmountInputUpdated() :Observable<number> {
    return this.amountInput$.asObservable().pipe(
      debounceTime(1000), // 1 sec delay
      distinctUntilChanged(),
      tap((data :any) => {
        const matchedOverride = this.pricingOverrides.find(
          (override) =>
            override.priceLevelId === data.priceLevelId &&
            override.priceScheduleTierId === data.priceScheduleTierId,
        );
        this.tierOverride.emit({ ...data, priceOverride: matchedOverride });
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
